// Towns API service

export interface Town {
    town_id: number
    name: string
}

export interface TownsListResponse {
    towns: Town[]
}

class TownsApi {
    private baseUrl: string

    constructor() {
        // Uses relative URLs for nginx proxy (same pattern as api.ts)
        this.baseUrl = ''
    }

    /**
     * Get all towns for dropdown selection
     */
    async getAll(): Promise<Town[]> {
        const response = await fetch(`${this.baseUrl}/api/towns`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })

        if (!response.ok) {
            throw new Error(`Failed to fetch towns: ${response.statusText}`)
        }

        const data: TownsListResponse = await response.json()
        return data.towns
    }
}

// Export singleton instance
export const townsApi = new TownsApi()
